import { ComparableToken, TokenFactory } from './token';
import { UnitValue } from '../taquito-michelson-encoder';

export class UnitToken extends ComparableToken {
  static prim = 'unit';

  constructor(
    protected val: { prim: string; args: any[]; annots: any[] },
    protected idx: number,
    protected fac: TokenFactory
  ) {
    super(val, idx, fac);
  }

  public Encode(args: any[]): any {
    args.pop();
    return { prim: 'Unit' };
  }

  public EncodeObject(_val: any): any {
    return { prim: 'Unit' };
  }

  public Execute(_val: { prim: string }) {
    return UnitValue;
  }

  public ExtractSchema() {
    return UnitToken.prim;
  }

  compare(_val1: any, _val2: any) {
    return 0;
  }

  ToKey(_val: any) {
    return UnitValue;
  }

  ToBigMapKey(_val: any) {
    return {
      key: { prim: 'Unit' },
      type: { prim: UnitToken.prim },
    };
  }
}
